import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import Toaster from './components/Toaster';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster />
        <Outlet />
      </div>
    </AuthProvider>
  );
}

export default App;
